import classNames from 'classnames';
import { ButtonCustom } from '../ButtonCustom';
import styles from './styles/mini_banner.module.scss';

export const MiniBanner = ({
  text,
  badgeText,
  buttonText,
  backgroundColor,
  scrollToId,
}) => {
  const miniBannerClassnames = classNames({
    [styles.mini_banner]: true,
  });

  const inlineStyle = backgroundColor ? { background: backgroundColor } : {};

  const handleClick = () => {
    document
      .getElementById(scrollToId)
      .scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className={miniBannerClassnames} style={inlineStyle}>
      <div className={styles.mini_banner__content}>
        <div className={styles.mini_banner__description}>
          <div className={styles.mini_banner__description_badge}>
            {badgeText}
          </div>
          <h4 className={styles.mini_banner__description_text}>{text}</h4>
        </div>
        <ButtonCustom text={buttonText} variant="ghost" onClick={handleClick} />
      </div>
    </div>
  );
};
